import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors duration-200 flex items-center gap-1">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-home-4-line text-xs"></i>
            </div>
            海角论坛
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const catInfo = categories.find((c) => c.name === item.label);
          return (
            <li key={index} className="flex items-center gap-1">
              <span className="mx-1 text-foreground-300">/</span>
              {isLast || !item.href ? (
                <span className="text-foreground-700 font-medium">{item.label}</span>
              ) : (
                <Link to={item.href} className="hover:text-primary-500 transition-colors duration-200">
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}